module.exports = __webpack_public_path__ + "img/bamboo-builders-white.758b9c88.png";